<script lang="ts" setup>
import { type PaletteColorProp } from '.';

const { color = 'var(--cool-gray-100)', size = 'small' } = defineProps<{
    size?: SizeConditional<'small' | 'medium'>;
    color?: PaletteColorProp | string;
}>();

const { mobile: mSize, desktop: dSize } = useExtractSize(() => size, 'medium');
</script>

<template>
    <div
        :class="[`m-${mSize}`, `d-${dSize}`]"
        class="mr-chips"
        :style="{ '--color': color }"
    >
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.mr-chips {
    display: flex;
    justify-content: center;
    align-items: center;
    background: v-bind(color) !important;
    border-radius: 8px;
    padding: 2px 8px;
    flex-shrink: 0;
}
.m-small {
    @include mobile-only {
        height: 28px;
    }
}

.m-medium {
    @include mobile-only {
        height: 28px;
    }
}
.d-small {
    @include desktop-only {
        height: 28px;
    }
}

.d-medium {
    @include desktop-only {
        height: 28px;
    }
}
</style>
